import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SidebarMenu from "../Administrador/AdminPanel/SidebarMenu";
import TopBar from "../Administrador/AdminPanel/TopBar";
import EnterpriseConfig from "./EnterpriseConfig";
import ElectronicInvoice from "./ElectronicInvoice";
import EnterpriseUsers from "./EnterpriseUsers";
import EnterpriseMail from "./EnterpriseMail";
import EnterpriseTemplates from "./EnterpriseTemplates";
import EnterpriseSystem from "./EnterpriseSystem";

const EnterprisePanel = () => {
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const isSuper = localStorage.getItem("is_superuser") === "true";
  const isAdmin = localStorage.getItem("is_admin") === "true";

  useEffect(() => {
    if (!isSuper && !isAdmin) navigate("/login");
  }, [isSuper, isAdmin, location, navigate]);

  const handleLogout = async () => {
    try {
      await fetch("/sistema/logout/", {
        method: "POST",
        credentials: "include",
      });
    } catch {}

    localStorage.removeItem("user_email");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("is_admin");
    localStorage.removeItem("is_logged_in");

    navigate("/login");
  };

  const handleTabChange = (_e, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f6fa" }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        handleSelect={() => {}}
        handleLogout={handleLogout}
        navigate={navigate}
      />

      <Box sx={{ flexGrow: 1, transition: "all 0.3s ease" }}>
        <TopBar open={open} setOpen={setOpen} />

        <Box sx={{ width: "95%", mx: "auto", mt: 4 }}>
          <Typography
            variant="h5"
            sx={{
              color: "#1565C0",
              fontWeight: 800,
              mb: 2,
              ml: "1.7rem",
            }}
          >
            Mi Compañía
          </Typography>

          <Paper
            sx={{
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #e0e0e0",
              boxShadow: "none",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons={false}
              sx={{
                backgroundColor: "#1565C0",
                "& .MuiTab-root": {
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 600,
                  minHeight: "48px",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                  transition: "all 0.2s ease",
                },
                "& .Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#1565C0",
                  borderTop: "4px solid #1565C0",
                  borderLeft: "4px solid #1565C0",
                  borderRight: "4px solid #1565C0",
                  borderBottom: "none",
                  marginTop: "5px",
                  marginLeft: "10px",
                },
                "& .MuiTabs-indicator": {
                  display: "none",
                },
              }}
            >
              <Tab label="General" />
              <Tab label="Usuarios" />
              <Tab label="Facturación Electrónica" />
              <Tab label="Correos" />
              <Tab label="Plantillas" />
              <Tab label="Sistema" />
            </Tabs>

            <Box sx={{ p: 3 }}>
              {tabValue === 0 && (
                <EnterpriseConfig canEditUserLimit={isSuper} />
              )}

              {tabValue === 1 && (
                <EnterpriseUsers
                  canSeeSuperUsers={isSuper}
                  canCreateSuperUsers={isSuper}
                />
              )}

              {tabValue === 2 && <ElectronicInvoice />}
              {tabValue === 3 && <EnterpriseMail />}
              {tabValue === 4 && <EnterpriseTemplates />}
              {tabValue === 5 && <EnterpriseSystem />}
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default EnterprisePanel;